/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';
import type AdverseEventModel from 'parog-web/models/adverse-event';

interface ContinuousRangeSignature {
  form: ForcProviderBaseSignature['Blocks']['default'][0];
  adverseEvent: AdverseEventModel;
}

const ContinuousRange: TOC<ContinuousRangeSignature> = <template>
  {{! prettier-ignore }}
  <@form.Range
              {{! @glint-expect-error }}
      @label={{t (concat 'adverse-event.labels.' this.adverseEvent.id) default='adverse-event.labels.other' }}
      @payloadKey='evaScore'
              {{! @glint-expect-error }}
      @min={{0}}
              {{! @glint-expect-error }}
      @max={{10}}
              {{! @glint-expect-error }}
      @step={{0.1}}
      @minLabel='Pas de gêne ou de douleur'
      @maxLabel='Gêne ou douleur maximale'
      class='mb-12 flex flex-col'
    >
      <:values>
        <div class='mt-[8px] flex justify-between'>
          <label class='max-w-[25%] text-center'>Pas de gêne ou de douleur</label>
          <label class='max-w-[25%] text-center'>Gêne ou douleur maximale</label>
        </div>
      </:values>
    </@form.Range>
</template>;

export default ContinuousRange;
